import { useQuery } from "@tanstack/react-query"
import useAppStore from "../../../../zustand/new-store"
import { AxiosError } from "axios"
import { useAuth } from "@clerk/clerk-react"
import { Intervals } from "../../../../types/dashboard-chart-types"
import { getMethodTraffic } from "../../../../api/server/analytics/method-traffic"
import { ANALYTICS_REFETCH_INTERVAL } from "../../../../constants/analytics-refetch"

const useMethodMetrics = (interval: Intervals) => {
	const { cacheConfig } = useAppStore()
	const { getToken } = useAuth()
	return useQuery<{
		meta: {
			name: string
			type: string
		}[]
		data: {
			request_method: string
			count: string
		}[]
		rows: number
	}>({
		queryKey: [cacheConfig?.host, interval, "method traffic"],
		refetchOnWindowFocus: false,
		refetchInterval: data => {
			if (!data) {
				return false
			} else {
				return ANALYTICS_REFETCH_INTERVAL
			}
		},
		retry: 1,
		queryFn: async () => {
			const token = await getToken()
			if (!token) {
				throw new AxiosError("Unauthenticated")
			}
			return getMethodTraffic({
				token,
				interval,
				host: cacheConfig?.host || "",
			})
		},
	})
}

export default useMethodMetrics
